export default "__VITE_ASSET__BXY7uVmd__"